/** Профиль, залы, синхронизация — сообщения и подписи. */
export const PROFILE_EXTRA_RU = {
  'profile.gymNameRequired': 'Укажите название зала',
  'profile.gymOfflineSaved': 'Зал сохранён офлайн — синхронизируем при подключении',
  'profile.gymAdded': 'Зал добавлен',
  'profile.gymAddFail': 'Не удалось добавить зал',
  'profile.gymEditOffline': 'Изменения зала сохранены офлайн',
  'profile.gymUpdated': 'Зал обновлён',
  'profile.gymSaveFail': 'Не удалось сохранить зал',
  'profile.gymDeleteQueued': 'Удаление зала поставлено в очередь (офлайн)',
  'profile.gymDeleted': 'Зал удалён',
  'profile.gymDeleteFail': 'Не удалось удалить зал',
  'profile.nameLen': 'Имя должно содержать минимум 3 символа',
  'profile.nameRequiredSave': 'Введите имя для сохранения пользователя',
  'profile.emailInvalid': 'Введите корректный email адрес',
  'profile.nicknameSaveFail': 'Не удалось сохранить: ошибка никнейма',
  'profile.changesSaved': 'Изменения сохранены',
  'profile.saveError': 'Ошибка при сохранении изменений',
  'profile.emailInUse': 'Этот email уже используется',
  'profile.trainerNameSaved': 'Имя сохранено',
  'profile.nameSaveError': 'Ошибка при сохранении',
  'profile.deleteFail': 'Не удалось удалить профиль',
  'profile.syncCodeFail': 'Не удалось сгенерировать код',
  'profile.copied': 'Скопировано',
  'profile.syncEnterIdCode': 'Введите ID и код',
  'profile.syncVerifyFail': 'Не удалось проверить код',
  'profile.syncMergedFull': 'Аккаунты объединены',
  'profile.syncMergedLogin': 'Входы объединены в один профиль',
  'profile.syncMergeFail': 'Не удалось объединить аккаунты',
  'profile.avatarUpdated': 'Аватар обновлен',
  'profile.avatarError': 'Ошибка при обновлении аватара',
  'profile.pickImage': 'Пожалуйста, выберите изображение',
  'profile.imageTooLarge': 'Размер файла не должен превышать 5 МБ',
  'profile.avatarUploadError': 'Ошибка при загрузке аватара',
  'profile.fileReadError': 'Ошибка при чтении файла',
  'profile.fileProcessError': 'Ошибка при обработке файла',
  'profile.changeAvatar': 'Изменить аватар',
  'profile.changePhoto': 'Изменить фото',
  'profile.yourNamePlaceholder': 'Ваше имя',
  'profile.nameAria': 'Имя',
  'profile.saveTitle': 'Сохранить',
  'profile.cancelTitle': 'Отмена',
  'profile.roleTrainerDefault': 'Тренер',
  'profile.roleClientDefault': 'Клиент',
  'profile.emailField': 'Email',
  'profile.editNameTitle': 'Изменить имя',
  'profile.avatarPickerTitle': 'Выберите аватар',
  'profile.phonePlaceholder': 'Введите телефон',
  'profile.emailPlaceholder': 'Введите email',
  'profile.instagramPlaceholder': 'Введите username',
  'profile.genderPlaceholder': 'Выберите пол',
  'profile.gender.male': 'Мужской',
  'profile.gender.female': 'Женский',
  'profile.gender.unspecified': 'Не указан',
  'profile.heightPlaceholder': 'Введите рост',
  'profile.weightPlaceholder': 'Введите вес',
  'profile.linksPlaceholder': 'Введите ссылку',
  'profile.gymEditTitle': 'Изменить',
  'profile.gymDeleteTitle': 'Удалить',
  'profile.gymNamePlaceholder': 'Введите название зала',
  'profile.gymAddressPlaceholder': 'Введите адрес',
  'profile.gymEditDialogTitle': 'Редактировать зал',
  'profile.gymDeleteTitleDlg': 'Удалить зал?',
  'profile.gymDeleteConfirm':
    'Зал «{name}» будет удалён. Тренировки с этим залом могут потребовать обновления.',
  'profile.languageAria': 'Язык интерфейса',
  'profile.syncCurrent': 'Текущий аккаунт',
  'profile.syncTarget': 'Найденный аккаунт',
  'profile.noEmail': 'нет email',
  'profile.deleteForever': 'Удалить навсегда',
  'profile.myGyms': 'Мои залы',
  'profile.gymsLoading': 'Загрузка залов…',
  'profile.gymsEmpty': 'Пока нет залов.',
  'profile.addGym': 'Добавить зал',
  'profile.gymNameLabel': 'Название *',
  'profile.gymAddressLabel': 'Адрес',
  'profile.gymDefaultCheckbox': 'Сделать залом по умолчанию',
  'profile.gymAdding': 'Добавляем…',
  'profile.gymDefaultEdit': 'Зал по умолчанию',
  'profile.linksFieldHint': 'Укажите ссылки на социальные сети или мессенджеры',
  'profile.linksFieldLabel': 'Ссылки (Instagram, Telegram и т.д.)',
  'profile.personalTitle': 'Персональная информация',
  'profile.loadingProfile': 'Загрузка профиля…',
  'profile.phoneLabel': 'Телефон',
  'profile.genderFieldLabel': 'Пол',
  'profile.linksAccordion': 'Ссылки',
  'profile.heightStat': 'Рост',
  'profile.weightStat': 'Вес',
  'profile.heightCm': 'Рост (см)',
  'profile.weightKg': 'Вес (кг)',
  'profile.gymNoAddress': 'Адрес не указан',
  'profile.deleteAccountDeleting': 'Удаление…',
  'profile.editProfile': 'Редактировать профиль',
  'profile.accountDanger': 'Опасная зона',
  'profile.syncWorkoutsCount': '{n} тренировок',
  'profile.syncClientsCount': '{n} клиентов',
  'profile.syncSaving': 'Сохранение…',
  'profile.deleteProfile': 'Удалить профиль',
  'profile.deleteProfileTitle': 'Удалить профиль?',
  'profile.deleteProfileBody':
    'Аккаунт будет закрыт: вход станет невозможен, личные данные в профиле сброшены.',
  'profile.deleteProfileConfirm': 'Я понимаю последствия и хочу удалить профиль',
};

export const PROFILE_EXTRA_EN = {
  'profile.gymNameRequired': 'Enter the gym name',
  'profile.gymOfflineSaved': 'Gym saved offline — will sync when online',
  'profile.gymAdded': 'Gym added',
  'profile.gymAddFail': 'Couldn’t add gym',
  'profile.gymEditOffline': 'Gym changes saved offline',
  'profile.gymUpdated': 'Gym updated',
  'profile.gymSaveFail': 'Couldn’t save gym',
  'profile.gymDeleteQueued': 'Gym delete queued (offline)',
  'profile.gymDeleted': 'Gym removed',
  'profile.gymDeleteFail': 'Couldn’t remove gym',
  'profile.nameLen': 'Name must be at least 3 characters',
  'profile.nameRequiredSave': 'Enter a name to save',
  'profile.emailInvalid': 'Enter a valid email',
  'profile.nicknameSaveFail': 'Couldn’t save: nickname error',
  'profile.changesSaved': 'Changes saved',
  'profile.saveError': 'Couldn’t save changes',
  'profile.emailInUse': 'This email is already in use',
  'profile.trainerNameSaved': 'Name saved',
  'profile.nameSaveError': 'Couldn’t save name',
  'profile.deleteFail': 'Couldn’t delete account',
  'profile.syncCodeFail': 'Couldn’t generate code',
  'profile.copied': 'Copied',
  'profile.syncEnterIdCode': 'Enter ID and code',
  'profile.syncVerifyFail': 'Couldn’t verify code',
  'profile.syncMergedFull': 'Accounts merged',
  'profile.syncMergedLogin': 'Sign-in methods linked to one profile',
  'profile.syncMergeFail': 'Couldn’t merge accounts',
  'profile.avatarUpdated': 'Photo updated',
  'profile.avatarError': 'Couldn’t update photo',
  'profile.pickImage': 'Please choose an image',
  'profile.imageTooLarge': 'File must be 5 MB or smaller',
  'profile.avatarUploadError': 'Couldn’t upload photo',
  'profile.fileReadError': 'Couldn’t read file',
  'profile.fileProcessError': 'Couldn’t process file',
  'profile.changeAvatar': 'Change photo',
  'profile.changePhoto': 'Change photo',
  'profile.yourNamePlaceholder': 'Your name',
  'profile.nameAria': 'Name',
  'profile.saveTitle': 'Save',
  'profile.cancelTitle': 'Cancel',
  'profile.roleTrainerDefault': 'Trainer',
  'profile.roleClientDefault': 'Client',
  'profile.emailField': 'Email',
  'profile.editNameTitle': 'Edit name',
  'profile.avatarPickerTitle': 'Choose avatar',
  'profile.phonePlaceholder': 'Phone number',
  'profile.emailPlaceholder': 'Email',
  'profile.instagramPlaceholder': 'Username',
  'profile.genderPlaceholder': 'Gender',
  'profile.gender.male': 'Male',
  'profile.gender.female': 'Female',
  'profile.gender.unspecified': 'Prefer not to say',
  'profile.heightPlaceholder': 'Height',
  'profile.weightPlaceholder': 'Weight',
  'profile.linksPlaceholder': 'Link',
  'profile.gymEditTitle': 'Edit',
  'profile.gymDeleteTitle': 'Delete',
  'profile.gymNamePlaceholder': 'Gym name',
  'profile.gymAddressPlaceholder': 'Address',
  'profile.gymEditDialogTitle': 'Edit gym',
  'profile.gymDeleteTitleDlg': 'Remove gym?',
  'profile.gymDeleteConfirm':
    '“{name}” will be removed. Workouts tied to it may need updating.',
  'profile.languageAria': 'Interface language',
  'profile.syncCurrent': 'This account',
  'profile.syncTarget': 'Other account',
  'profile.noEmail': 'no email',
  'profile.deleteForever': 'Delete permanently',
  'profile.myGyms': 'My gyms',
  'profile.gymsLoading': 'Loading gyms…',
  'profile.gymsEmpty': 'No gyms yet.',
  'profile.addGym': 'Add gym',
  'profile.gymNameLabel': 'Name *',
  'profile.gymAddressLabel': 'Address',
  'profile.gymDefaultCheckbox': 'Default gym',
  'profile.gymAdding': 'Adding…',
  'profile.gymDefaultEdit': 'Default gym',
  'profile.linksFieldHint': 'Social or messenger links',
  'profile.linksFieldLabel': 'Links (Instagram, Telegram, etc.)',
  'profile.personalTitle': 'Personal information',
  'profile.loadingProfile': 'Loading profile…',
  'profile.phoneLabel': 'Phone',
  'profile.genderFieldLabel': 'Gender',
  'profile.linksAccordion': 'Links',
  'profile.heightStat': 'Height',
  'profile.weightStat': 'Weight',
  'profile.heightCm': 'Height (cm)',
  'profile.weightKg': 'Weight (kg)',
  'profile.gymNoAddress': 'No address',
  'profile.deleteAccountDeleting': 'Deleting…',
  'profile.editProfile': 'Edit profile',
  'profile.accountDanger': 'Danger zone',
  'profile.syncWorkoutsCount': '{n} workouts',
  'profile.syncClientsCount': '{n} clients',
  'profile.syncSaving': 'Saving…',
  'profile.deleteProfile': 'Delete profile',
  'profile.deleteProfileTitle': 'Delete profile?',
  'profile.deleteProfileBody':
    'Your account will be closed: you won’t be able to sign in, and profile details will be cleared.',
  'profile.deleteProfileConfirm': 'I understand and want to delete my profile',
};

export const PROFILE_EXTRA_ES = {
  'profile.gymNameRequired': 'Indica el nombre del gimnasio',
  'profile.gymOfflineSaved': 'Gimnasio guardado sin conexión — sincronizaremos al volver online',
  'profile.gymAdded': 'Gimnasio añadido',
  'profile.gymAddFail': 'No se pudo añadir el gimnasio',
  'profile.gymEditOffline': 'Cambios del gimnasio guardados sin conexión',
  'profile.gymUpdated': 'Gimnasio actualizado',
  'profile.gymSaveFail': 'No se pudo guardar el gimnasio',
  'profile.gymDeleteQueued': 'Eliminación del gimnasio en cola (sin conexión)',
  'profile.gymDeleted': 'Gimnasio eliminado',
  'profile.gymDeleteFail': 'No se pudo eliminar el gimnasio',
  'profile.nameLen': 'El nombre debe tener al menos 3 caracteres',
  'profile.nameRequiredSave': 'Introduce un nombre para guardar',
  'profile.emailInvalid': 'Introduce un correo válido',
  'profile.nicknameSaveFail': 'No se pudo guardar: error de alias',
  'profile.changesSaved': 'Cambios guardados',
  'profile.saveError': 'No se pudieron guardar los cambios',
  'profile.emailInUse': 'Este correo ya está en uso',
  'profile.trainerNameSaved': 'Nombre guardado',
  'profile.nameSaveError': 'No se pudo guardar el nombre',
  'profile.deleteFail': 'No se pudo eliminar la cuenta',
  'profile.syncCodeFail': 'No se pudo generar el código',
  'profile.copied': 'Copiado',
  'profile.syncEnterIdCode': 'Introduce ID y código',
  'profile.syncVerifyFail': 'No se pudo verificar el código',
  'profile.syncMergedFull': 'Cuentas unidas',
  'profile.syncMergedLogin': 'Accesos fusionados en un solo perfil',
  'profile.syncMergeFail': 'No se pudieron unir las cuentas',
  'profile.avatarUpdated': 'Foto actualizada',
  'profile.avatarError': 'No se pudo actualizar la foto',
  'profile.pickImage': 'Elige una imagen',
  'profile.imageTooLarge': 'El archivo debe pesar como mucho 5 MB',
  'profile.avatarUploadError': 'No se pudo subir la foto',
  'profile.fileReadError': 'No se pudo leer el archivo',
  'profile.fileProcessError': 'No se pudo procesar el archivo',
  'profile.changeAvatar': 'Cambiar foto',
  'profile.changePhoto': 'Cambiar foto',
  'profile.yourNamePlaceholder': 'Tu nombre',
  'profile.nameAria': 'Nombre',
  'profile.saveTitle': 'Guardar',
  'profile.cancelTitle': 'Cancelar',
  'profile.roleTrainerDefault': 'Entrenador',
  'profile.roleClientDefault': 'Cliente',
  'profile.emailField': 'Correo',
  'profile.editNameTitle': 'Editar nombre',
  'profile.avatarPickerTitle': 'Elegir avatar',
  'profile.phonePlaceholder': 'Teléfono',
  'profile.emailPlaceholder': 'Correo',
  'profile.instagramPlaceholder': 'Usuario de Instagram',
  'profile.genderPlaceholder': 'Género',
  'profile.gender.male': 'Hombre',
  'profile.gender.female': 'Mujer',
  'profile.gender.unspecified': 'Prefiero no decirlo',
  'profile.heightPlaceholder': 'Altura',
  'profile.weightPlaceholder': 'Peso',
  'profile.linksPlaceholder': 'Enlace',
  'profile.gymEditTitle': 'Editar',
  'profile.gymDeleteTitle': 'Eliminar',
  'profile.gymNamePlaceholder': 'Nombre del gimnasio',
  'profile.gymAddressPlaceholder': 'Dirección',
  'profile.gymEditDialogTitle': 'Editar gimnasio',
  'profile.gymDeleteTitleDlg': '¿Eliminar gimnasio?',
  'profile.gymDeleteConfirm':
    'Se eliminará «{name}». Los entrenos vinculados pueden necesitar actualización.',
  'profile.languageAria': 'Idioma de la interfaz',
  'profile.syncCurrent': 'Esta cuenta',
  'profile.syncTarget': 'Otra cuenta',
  'profile.noEmail': 'sin correo',
  'profile.deleteForever': 'Eliminar para siempre',
  'profile.myGyms': 'Mis gimnasios',
  'profile.gymsLoading': 'Cargando gimnasios…',
  'profile.gymsEmpty': 'Aún no hay gimnasios.',
  'profile.addGym': 'Añadir gimnasio',
  'profile.gymNameLabel': 'Nombre *',
  'profile.gymAddressLabel': 'Dirección',
  'profile.gymDefaultCheckbox': 'Gimnasio predeterminado',
  'profile.gymAdding': 'Añadiendo…',
  'profile.gymDefaultEdit': 'Predeterminado',
  'profile.linksFieldHint': 'Enlaces a redes o mensajería',
  'profile.linksFieldLabel': 'Enlaces (Instagram, Telegram, etc.)',
  'profile.personalTitle': 'Datos personales',
  'profile.loadingProfile': 'Cargando perfil…',
  'profile.phoneLabel': 'Teléfono',
  'profile.genderFieldLabel': 'Género',
  'profile.linksAccordion': 'Enlaces',
  'profile.heightStat': 'Altura',
  'profile.weightStat': 'Peso',
  'profile.heightCm': 'Altura (cm)',
  'profile.weightKg': 'Peso (kg)',
  'profile.gymNoAddress': 'Sin dirección',
  'profile.deleteAccountDeleting': 'Eliminando…',
  'profile.editProfile': 'Editar perfil',
  'profile.accountDanger': 'Zona peligrosa',
  'profile.syncWorkoutsCount': '{n} entrenos',
  'profile.syncClientsCount': '{n} clientes',
  'profile.syncSaving': 'Guardando…',
  'profile.deleteProfile': 'Eliminar perfil',
  'profile.deleteProfileTitle': '¿Eliminar perfil?',
  'profile.deleteProfileBody':
    'La cuenta se cerrará: no podrás iniciar sesión y los datos del perfil se borrarán.',
  'profile.deleteProfileConfirm': 'Entiendo las consecuencias y quiero eliminar mi perfil',
};
